export var AmplifyFeature;
(function (AmplifyFeature) {
    AmplifyFeature["Retargeting"] = "retargeting";
    AmplifyFeature["MetasearchAds"] = "metasearchAds";
    AmplifyFeature["PMax"] = "pmax";
})(AmplifyFeature || (AmplifyFeature = {}));
